
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.195 19.195c0-2.288.418-4.534 1.255-6.737.836-2.204 1.797-3.983 2.884-5.34a25.46 25.46 0 013.513-3.813c1.338-1.186 2.341-1.991 3.01-2.415.67-.424 1.13-.72 1.38-.89l3.387 3.56c-.502.423-1.13 1.059-1.882 1.906-.92 1.102-1.84 2.5-2.76 4.195-1.17 1.95-1.672 3.687-1.505 5.212 1.84.254 3.387 1.102 4.641 2.542C35.373 18.855 36 20.551 36 22.5c0 2.119-.753 3.898-2.258 5.339C32.321 29.279 30.565 30 28.474 30c-2.425 0-4.432-.975-6.021-2.924-1.505-2.034-2.258-4.66-2.258-7.881zM0 19.195c0-2.288.418-4.534 1.254-6.737.837-2.204 1.798-3.983 2.885-5.34a25.462 25.462 0 013.513-3.813C8.99 2.12 9.993 1.314 10.662.89c.669-.424 1.129-.72 1.38-.89l3.387 3.56c-.502.423-1.13 1.059-1.882 1.906-.92 1.102-1.84 2.5-2.76 4.195-1.17 1.95-1.672 3.687-1.505 5.212 1.84.254 3.387 1.102 4.641 2.542 1.255 1.44 1.882 3.136 1.882 5.085 0 2.119-.753 3.898-2.258 5.339C12.125 29.279 10.369 30 8.279 30c-2.425 0-4.432-.975-6.021-2.924C.753 25.042 0 22.416 0 19.195z","fill":"#56BFC7"}})])
          )
        }
      }
    